import { useEffect } from 'react';

/**
 * Custom hook to track events using Amplitude.
 *
 * This hook checks if the Amplitude library is loaded. If it is, it immediately calls the
 * provided `trackEvent` function. If not, it sets up an event listener for the
 * 'ResyAmplitudeLoaded' event, which will call `trackEvent` once the library is available.
 *
 * @param {Function} trackEvent - The function to call when tracking an event.
 *
 * @returns {void}
 */
const useTrackEvent = (trackEvent) => {
  useEffect(() => {
    if (window.amplitude) {
      trackEvent();
    } else {
      window.addEventListener('ResyAmplitudeLoaded', trackEvent);
    }

    return () => window.removeEventListener('ResyAmplitudeLoaded', trackEvent);
  }, []);
};

export default useTrackEvent;
